// extracted by mini-css-extract-plugin
module.exports = {"form-item":"styles_form-item__3-Mpv","input-text":"styles_input-text__2KBt7","field-li":"styles_field-li__scIp2"};